import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Home from "./components/home/Home";
import Company from "./components/company/Company";
import Footer from "./components/footer/Footer";
import Navbar from "./components/navbar/Navbar";
// import Partners from "./components/partners/Partners"; // Hidden
import Products from "./components/products/Products";
import Research from "./components/research/Research";
// import Services from "./components/services/Services"; // Hidden - replaced with separate pages
import ITServices from "./components/itservices/ITServices";
import Staffing from "./components/staffing/Staffing";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Careers from "./components/careers/Careers";
import ContactUsForm from "./components/ContactUsForm/ContactUsForm";
// import Blogs from "./components/Blogs/Blogs"; // Hidden
import Events from "./components/Events/Events";
import Testimonials from "./components/Testimonials/Testimonials";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";
import RequireAdmin from "./components/admin/RequireAdmin";
// Marketplace components hidden
// import Marketplace from "./components/Marketplace/Marketplace";
// import MarketplaceDetailsPage from "./components/MarketplaceDetailsPage/MarketplaceDetailsPage";

const App = () => {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="products" element={<Products />} />
        {/* Services route hidden - replaced with separate pages */}
        {/* <Route path="services" element={<Services />} /> */}
        <Route path="itservices" element={<ITServices />} />
        <Route path="staffing" element={<Staffing />} />
        <Route path="research" element={<Research />} />
        {/* <Route path="partners" element={<Partners />} /> */}
        <Route path="aboutus" element={<Company />} />
        <Route path="careers" element={<Careers />} />
        {/* Marketplace routes hidden */}
        {/* <Route path="marketplace">
          <Route index element={<Marketplace />} />
          <Route path=":solutionId" element={<MarketplaceDetailsPage />} />
        </Route> */}
        <Route path="contactus" element={<ContactUsForm />} />
        {/* <Route path="blogs" element={<Blogs />} /> */}
        <Route path="events" element={<Events />} />
        <Route path="testimonials" element={<Testimonials />} />
        <Route path="admin/login" element={<AdminLogin />} />
        <Route
          path="admin"
          element={
            <RequireAdmin>
              <AdminDashboard />
            </RequireAdmin>
          }
        />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
};

export default App;
